import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { red } from '@mui/material/colors';

import ClientPrioritaireIcon from '@mui/icons-material/WarningTwoTone';

import { MarcheType } from 'constants.js';


const styles = theme => ({

    prioritaire: {
        //color: 'black',
        //textShadow: '1px 1px 2px #f04e23, -1px -1px 3px DarkGoldenRod, 0px 0px 10px Gold',
        //letterSpacing: '2px',
        //fontSize: '1em'
    }
});


const badgeBaseSx = {
    width: 24,
    height: 24,
    fontSize: '0.50rem',
    border: '1px solid black',
    boxShadow: 2,
    ml: 1
};

const MarcheBadge = ({ marcheType }) => {

    if (marcheType === MarcheType.Prive) {
        return <Avatar sx={{ ...badgeBaseSx, backgroundColor: 'client.marche.prive' }}>MPR</Avatar>;
    }

    if (marcheType === MarcheType.Public) {
        return <Avatar sx={{ ...badgeBaseSx, backgroundColor: 'client.marche.public' }}>MPU</Avatar>;
    }

    return null;
};

const isPrioritaire = (client) =>
    Boolean(client && (client.prioritaire || (client.parent && client.parent.prioritaire)));

const PrioritaireBadge = ({ client }) => {

    if (!isPrioritaire(client)) {
        return null;
    }

    return (
        <Tooltip title="Client prioritaire">
            <ClientPrioritaireIcon sx={{ color: red[500], ml: 0.5, verticalAlign: 'middle' }} />
        </Tooltip>
    );
};


class Client extends React.Component {

    render() {

        const { classes, client, format, withTooltip, prioritaire, showMarcheBadge, showPrioritaireBadge } = this.props;

        if (!client) {
            return null;
        }

        let _format = format;
        if (!_format) {
            _format = "code-libelle";
        }

        let _prioritaire = false;
        if (prioritaire !== undefined && prioritaire !== null) {
            _prioritaire = prioritaire;
        }

        if (!client.code && !client.libelle ) {
            return '';
        }

        let str = '';

        if (_format === "code-libelle") {

            str = client.libelle ? client.code + ' - '  + client.libelle : client.code;

        }

        if (_format === "code") {

            str = client.code;

        }

        // Cas avec badge(s) : on doit retourner un noeud composite, pas une simple string.
        if (showMarcheBadge || showPrioritaireBadge) {
            const inner = (
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <span className={_prioritaire ? classes.prioritaire : ''}>{str}</span>
                    {showMarcheBadge && <MarcheBadge marcheType={client.marcheType} />}
                    {showPrioritaireBadge && <PrioritaireBadge client={client} />}
                </Box>
            );

            if (withTooltip) {
                let title = client.libelle ? client.code + ' - ' + client.libelle : client.code;
                if (client.parent) {
                    let parentTitle = client.parent.libelle ? client.parent.code + ' - ' + client.parent.libelle : client.parent.code;
                    if (parentTitle) {
                        title += ' < ' + parentTitle;
                    }
                }
                return <Tooltip title={title}>{inner}</Tooltip>;
            }

            return inner;
        }

        if (withTooltip) {

            let title = client.libelle ? client.code + ' - ' + client.libelle : client.code;

            if (client.parent) {
                let parentTitle = client.parent.libelle ? client.parent.code + ' - ' + client.parent.libelle : client.parent.code;
                if (parentTitle) {
                    title += ' < ' + parentTitle;
                }
            }

            return <Tooltip title={title}><p className={_prioritaire ? classes.prioritaire : ''}>{str}</p></Tooltip>;
        }

        if (_prioritaire) {
            return <p className={classes.prioritaire}>{str}</p>;
        }

        return str;

    }
}

Client.propTypes = {
    client: PropTypes.object,
    format: PropTypes.string,
    withTooltip: PropTypes.bool,
    prioritaire: PropTypes.bool,
    showMarcheBadge: PropTypes.bool,
    showPrioritaireBadge: PropTypes.bool
};

Client.defaultProps = {
    showMarcheBadge: false,
    showPrioritaireBadge: false
};

export default withStyles(styles)(Client);
